<script setup lang="ts">
const emit = defineEmits(["close", "cancelComplete"]);
defineProps({
  collectible: {
    type: Object as PropType<Collectible>,
    required: true,
  },
});

const { trackEvent } = useGAnalytics();
const isLoading = ref(false);

const cancelListing = () => {
  trackEvent("list_cancel_button");
  isLoading.value = true;
  setTimeout(() => {
    emit("cancelComplete");
  }, 500);
};
</script>
<template>
  <div class="flex flex-col gap-y-6">
    <img
      class="w-32 object-contain border border-secondary-500 mx-auto"
      :src="getPortraitItemImage(collectible.imageId)"
      @error="
        (e) => ((e.target as HTMLImageElement).src = getPortraitItemImage())
      " />
    <i18n-t
      tag="p"
      class="text-neutral-300 text-center max-w-xs mx-auto"
      keypath="main.modalList.unlist"
      scope="global">
      <template #item>
        <span class="font-bold text-neutral-200">{{
          $t(`${collectible.translationId}.title`) +
          " " +
          $t(`${collectible.translationId}.subtitle`) +
          " #" +
          collectible.number
        }}</span>
      </template>
    </i18n-t>
    <div class="w-full mt-auto mb-2 flex items-center gap-4">
      <BaseButtonSubmit
        :loading="isLoading"
        :text="$t('main.modalList.unlistButton')"
        :disabled="isLoading"
        data-test="button-cancel-listing"
        :contextual-styles="true"
        @click="cancelListing" />
      <BaseButtonCancel
        :text="$t('main.modalList.cancel')"
        data-test="button-dismiss-cancel-listing"
        :contextual-styles="true"
        @click="$emit('close')" />
    </div>
  </div>
</template>
